export const PageDataState = {
    Searchs: {
        manpower_establishments_id: {
            type: 'select',
            id: 'manpower_establishments_id',
            label: 'รหัส',
            value: '',
            placeholder: 'รหัส',
        },
        skills_set_type_id: {
            type: 'select',
            id: 'skills_set_type_id',
            label: 'ประเภททักษะ',
            value: '',
            placeholder: 'ประเภททักษะ Skills Set',
        },
        skills_set_name: {
            type: 'text',
            id: 'skills_set_name',
            label: 'ทักษะ',
            value: '',
            placeholder: 'ทักษะ Skills Set',
        }
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false
            },
            error: { status: null, msg: '' }
        },
        manpower_establishments_id: {
            type: 'select',
            id: 'manpower_establishments_id',
            label: 'รหัสตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },        
        skills_set_type_id: {
            type: 'select',
            id: 'skills_set_type_id',
            label: 'ประเภททักษะ Skills Set',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        skills_set_id: {
            type: 'select',
            id: 'skills_set_id',
            label: 'ทักษะ Skills Set',
            value: '',
            validator: {
                type: 'text',
                required: false
            },
            error: { status: null, msg: '' }
        },
        explain: {
            type: 'textarea',
            rows: 3,
            id: 'explain',
            label: 'รายละเอียด',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },        
    },
    InputGroup: {}
}